// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file reservation_service.proto (package grpc.api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file reservation_service.proto.
 */
export const file_reservation_service: GenFile = /*@__PURE__*/
  fileDesc("ChlyZXNlcnZhdGlvbl9zZXJ2aWNlLnByb3RvEgtncnBjLmFwaS52MSJUChpSZXNlcnZhdGlvblNlcnZpY2VCbGFja291dBIbChNibGFja291dF9zdGFydF9kYXRlGAEgASgDEhkKEWJsYWNrb3V0X2VuZF9kYXRlGAIgASgDInQKHVJlc2VydmF0aW9uU2VydmljZVRyYW5zbGF0aW9uEg4KBmxvY2FsZRgBIAEoCRINCgV0aXRsZRgCIAEoCRITCgtkZXNjcmlwdGlvbhgDIAEoCRIRCglpbWFnZV91cmwYBCABKAkSDAoEdGFncxgFIAMoCSKrBgoSUmVzZXJ2YXRpb25TZXJ2aWNlEgoKAmlkGAEgASgDEgwKBGNvZGUYAiABKAkSDQoFb3JkZXIYAyABKAMSDQoFdGl0bGUYBCABKAkSEwoLZGVzY3JpcHRpb24YBSABKAkSEQoJaW1hZ2VfdXJsGAYgASgJEgwKBHRhZ3MYByADKAkSEAoId2Vla19kYXkYCCADKAUSEgoKc3RhcnRfZGF0ZRgJIAEoAxIQCghlbmRfZGF0ZRgKIAEoAxIWCg5taW5fcGFydHlfc2l6ZRgLIAEoBRIWCg5tYXhfcGFydHlfc2l6ZRgMIAEoBRISCgpzdGFydF90aW1lGA0gASgJEhAKCGVuZF90aW1lGA4gASgJEg4KBnRhYl9pZBgPIAEoAxIQCghkdXJhdGlvbhgQIAEoBRIOCgZsb2NhbGUYESABKAkSEwoLaXNfcHJvbW90ZWQYEiABKAgSEwoLaXNfcmVxdWlyZWQYEyABKAgSHgoWaXNfY3JlZGl0Y2FyZF9yZXF1aXJlZBgUIAEoCBINCgVwcmljZRgVIAEoAxIbChNpc19wcmljZV9wZXJfcGVyc29uGBYgASgIEhMKC2N1cnJlbmN5X2lkGBcgASgDEhIKCmR0X2NyZWF0ZWQYGCABKAMSEQoJZHRfdXBkYXRlGBkgASgDEhIKCmlzX2RlbGV0ZWQYGiABKAgSHgoWbWluX21pbnV0ZXNfaW5fYWR2YW5jZRgbIAEoBRIdChVtaW5fbWludXRlc190b19tb2RpZnkYHCABKAUSHQoVbWF4X3BhcmFsbGVsX2Jvb2tpbmdzGB8gASgFEhEKCWlzX2FjdGl2ZRggIAEoCBINCgVjb2xvchghIAEoCRISCgppc19kZXBvc2l0GCIgASgIEjoKCWJsYWNrb3V0cxgjIAMoCzInLmdycGMuYXBpLnYxLlJlc2VydmF0aW9uU2VydmljZUJsYWNrb3V0Eg8KB3RhYl9pZHMYJCADKAMSQAoMdHJhbnNsYXRpb25zGCUgAygLMiouZ3JwYy5hcGkudjEuUmVzZXJ2YXRpb25TZXJ2aWNlVHJhbnNsYXRpb25CBloELjtwYmIGcHJvdG8z");

/**
 * @generated from message grpc.api.v1.ReservationServiceBlackout
 */
export type ReservationServiceBlackout = Message<"grpc.api.v1.ReservationServiceBlackout"> & {
  /**
   * @generated from field: int64 blackout_start_date = 1;
   */
  blackoutStartDate: bigint;

  /**
   * @generated from field: int64 blackout_end_date = 2;
   */
  blackoutEndDate: bigint;
};

/**
 * Describes the message grpc.api.v1.ReservationServiceBlackout.
 * Use `create(ReservationServiceBlackoutSchema)` to create a new message.
 */
export const ReservationServiceBlackoutSchema: GenMessage<ReservationServiceBlackout> = /*@__PURE__*/
  messageDesc(file_reservation_service, 0);

/**
 * @generated from message grpc.api.v1.ReservationServiceTranslation
 */
export type ReservationServiceTranslation = Message<"grpc.api.v1.ReservationServiceTranslation"> & {
  /**
   * @generated from field: string locale = 1;
   */
  locale: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: string image_url = 4;
   */
  imageUrl: string;

  /**
   * @generated from field: repeated string tags = 5;
   */
  tags: string[];
};

/**
 * Describes the message grpc.api.v1.ReservationServiceTranslation.
 * Use `create(ReservationServiceTranslationSchema)` to create a new message.
 */
export const ReservationServiceTranslationSchema: GenMessage<ReservationServiceTranslation> = /*@__PURE__*/
  messageDesc(file_reservation_service, 1);

/**
 * @generated from message grpc.api.v1.ReservationService
 */
export type ReservationService = Message<"grpc.api.v1.ReservationService"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: int64 order = 3;
   */
  order: bigint;

  /**
   * @generated from field: string title = 4;
   */
  title: string;

  /**
   * @generated from field: string description = 5;
   */
  description: string;

  /**
   * @generated from field: string image_url = 6;
   */
  imageUrl: string;

  /**
   * @generated from field: repeated string tags = 7;
   */
  tags: string[];

  /**
   * @generated from field: repeated int32 week_day = 8;
   */
  weekDay: number[];

  /**
   * @generated from field: int64 start_date = 9;
   */
  startDate: bigint;

  /**
   * @generated from field: int64 end_date = 10;
   */
  endDate: bigint;

  /**
   * @generated from field: int32 min_party_size = 11;
   */
  minPartySize: number;

  /**
   * @generated from field: int32 max_party_size = 12;
   */
  maxPartySize: number;

  /**
   * @generated from field: string start_time = 13;
   */
  startTime: string;

  /**
   * @generated from field: string end_time = 14;
   */
  endTime: string;

  /**
   * @generated from field: int64 tab_id = 15;
   */
  tabId: bigint;

  /**
   * @generated from field: int32 duration = 16;
   */
  duration: number;

  /**
   * @generated from field: string locale = 17;
   */
  locale: string;

  /**
   * @generated from field: bool is_promoted = 18;
   */
  isPromoted: boolean;

  /**
   * @generated from field: bool is_required = 19;
   */
  isRequired: boolean;

  /**
   * @generated from field: bool is_creditcard_required = 20;
   */
  isCreditcardRequired: boolean;

  /**
   * @generated from field: int64 price = 21;
   */
  price: bigint;

  /**
   * @generated from field: bool is_price_per_person = 22;
   */
  isPricePerPerson: boolean;

  /**
   * @generated from field: int64 currency_id = 23;
   */
  currencyId: bigint;

  /**
   * @generated from field: int64 dt_created = 24;
   */
  dtCreated: bigint;

  /**
   * @generated from field: int64 dt_update = 25;
   */
  dtUpdate: bigint;

  /**
   * @generated from field: bool is_deleted = 26;
   */
  isDeleted: boolean;

  /**
   * @generated from field: int32 min_minutes_in_advance = 27;
   */
  minMinutesInAdvance: number;

  /**
   * @generated from field: int32 min_minutes_to_modify = 28;
   */
  minMinutesToModify: number;

  /**
   * int64 blackout_start_date = 29;
   * int64 blackout_end_date = 30;
   *
   * @generated from field: int32 max_parallel_bookings = 31;
   */
  maxParallelBookings: number;

  /**
   * @generated from field: bool is_active = 32;
   */
  isActive: boolean;

  /**
   * @generated from field: string color = 33;
   */
  color: string;

  /**
   * @generated from field: bool is_deposit = 34;
   */
  isDeposit: boolean;

  /**
   * @generated from field: repeated grpc.api.v1.ReservationServiceBlackout blackouts = 35;
   */
  blackouts: ReservationServiceBlackout[];

  /**
   * @generated from field: repeated int64 tab_ids = 36;
   */
  tabIds: bigint[];

  /**
   * @generated from field: repeated grpc.api.v1.ReservationServiceTranslation translations = 37;
   */
  translations: ReservationServiceTranslation[];
};

/**
 * Describes the message grpc.api.v1.ReservationService.
 * Use `create(ReservationServiceSchema)` to create a new message.
 */
export const ReservationServiceSchema: GenMessage<ReservationService> = /*@__PURE__*/
  messageDesc(file_reservation_service, 2);

